<template>
  <div class="container">
    <v-content v-if="watchedProducts.length">
      <search-results-title :query="watchedQuery" />
      <search-filters :current-category="watchedCategory" />
      <products-grid
        :products="watchedProducts"
        :max-grid-columns="4"
        :mobile-max-grid-columns="2"
      />
      <pagination
        :total-pages="watchedTotalPages"
        :current-page="watchedCurrentPage"
      />
    </v-content>
    <div v-else class="content">
      <search-without-result />
      <br /><br />
    </div>

    <shelf
      :shelf-products="{
        type: 'rich_relevance',
        richProducts: products,
        placement_name: 'search_page.rr1',
        see_more:
          this.$store.state.storeCode === 'br' ? 'capinha-para-celular' : null,
      }"
    />
  </div>
</template>

<script>
// import algoliasearch from 'algoliasearch/lite'

import ProductsGrid from '~/components/ProductsGrid.vue'
import SearchFilters from '~/components/search/search-filters/SearchFilters.vue'
import Pagination from '~/components/catalog/Pagination.vue'
import SearchWithoutResult from '~/components/search/search-without-result/SearchWithoutResult.vue'
import SearchResultsTitle from '~/components/search/search-results-title/SearchResultsTitle.vue'
import VContent from '~/components/shared/v-content/VContent'
import Shelf from '~/components/pages/shelf/Shelf.vue'

import appendUrlParam from '~/utils/appendUrlParam'
import isBlank from '~/utils/isBlank'
import adaptUrl from '~/commun/utils/adaptUrl'
import pushDataLayer from '~/mixins/gtm/push-data-layer'

import {
  // ALGOLIA_APP_ID,
  // ALGOLIA_API_KEY,
  GTM_PRODUCTS_QUANTITY,
} from '~/config'

import {
  initializeTypesenseClient,
  searchProductsByQuery,
  extractFiltersFromFacetCounts,
  buildSearchResultVariables,
} from '~/utils/typesense'

// const client = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY)

export default {
  name: 'SearchPage',
  components: {
    ProductsGrid,
    SearchFilters,
    SearchResultsTitle,
    SearchWithoutResult,
    Pagination,
    VContent,
    Shelf,
  },
  mixins: [pushDataLayer],
  async asyncData({
    $axios,
    store,
    redirect,
    route: {
      query: { q = '', category = '', page = 1 },
    },
    $sentry,
    $config,
    error,
    ...ctx
  }) {
    try {
      page -= 1

      const {
        storeCode,
        searcher: { lastCategories },
        globalDevice,
      } = store.state

      // Algolia
      // const indexName = `Spree_Product_site_${storeCode}_production`
      // const index = client.initIndex(indexName)
      // const tagFilters = ['shoppable', storeCode]

      // Typesense
      const typesenseClient = initializeTypesenseClient($config)

      const redirectEndpointUrl = appendUrlParam('/smart_redirect', {
        term: encodeURI(q),
        substore: store.state.substore?.code,
        ...store.getters.storeInfo,
      })

      if (!category && !page) {
        const smartRedirect = await $axios.$get(redirectEndpointUrl)

        if (smartRedirect.path) {
          const path = smartRedirect.path

          store.dispatch('searcher/setLoading', false)
          redirect(adaptUrl(path))
          return
        }
      }

      // typesense
      const typesenseResult = await searchProductsByQuery(
        typesenseClient,
        $config,
        q,
        category,
        page,
        storeCode
      )

      const {
        hits,
        currentPage,
        filters,
        totalPages,
      } = buildSearchResultVariables(typesenseResult)

      // algolia
      // const algoliaResult = await index.search(q, {
      //   attributesToRetrieve: ['id'],
      //   tagFilters,
      //   hitsPerPage: 24,
      //   facets: '*',
      //   facetFilters: [`product_type_code:${category}`],
      //   page,
      // })
      // const {
      //   hits,
      //   facets: { product_type_code: filters },
      //   nbPages: totalPages,
      //   page: currentPage,
      // } = algoliaResult

      if (!category && !page) {
        if (isBlank) store.dispatch('searcher/updateLastCategories', filters)
      } else if (isBlank(lastCategories)) {
        // algolia
        // const {
        //   facets: { product_type_code: firstFilters },
        // } = await index.search(q, {
        //   tagFilters,
        //   hitsPerPage: 0,
        //   facets: '*',
        //   page: 0,
        // })

        // typesense
        const typesenseFirstResult = await searchProductsByQuery(
          typesenseClient,
          $config,
          q,
          '',
          1,
          storeCode
        )
        const firstFilters = extractFiltersFromFacetCounts(
          // eslint-disable-next-line camelcase
          typesenseFirstResult?.facet_counts?.[0]?.counts
        )

        store.dispatch('searcher/updateLastCategories', firstFilters)
      }

      // algolia
      // const productIds = hits.map((hit) => hit.id)

      // typesense
      const productIds = hits?.map((hit) => hit?.document?.id)

      const params = {
        ...store.getters.storeInfo,
        product_ids: productIds.join(','),
      }
      let products = []
      try {
        if (globalDevice) {
          params.case_device = `${globalDevice.case_type_code}-${globalDevice.device_code}`
        }

        const productsEndpointUrl = appendUrlParam('/products/search', params)

        products = (await $axios.$get(productsEndpointUrl)).products
      } catch (err) {
        products = []
      }

      // TODO: DUO CASE GAMBI (DO IN BACKEND WHEN ISA BACK)
      if (globalDevice) {
        products = products.map((prod) => {
          if (prod.sku.startsWith('duo-')) {
            prod.image = prod.image.replace(
              params.case_device,
              'caseduocoral-iphone11'
            )
          } else if (prod.product_type_code === 'airpodcase') {
            prod.image = prod.image.replace(
              params.case_device,
              'transparent-airpod'
            )
          }
          return prod
        })
      }

      store.dispatch('searcher/setLoading', false)

      return {
        query: q,
        products,
        filters,
        category,
        totalPages,
        currentPage,
      }
    } catch (err) {
      error({
        statusCode: 500,
        message: 'Search not found',
      })
    }
  },
  data() {
    return {
      query: '',
      products: [],
      filters: {},
      category: '',
      totalPages: 1,
      currentPage: 1,
    }
  },
  computed: {
    watchedCurrentPage() {
      return this.currentPage + 1
    },
    watchedTotalPages() {
      return this.totalPages
    },
    watchedProducts() {
      return this.products
    },
    watchedQuery() {
      return this.query
    },
    watchedCategory() {
      return this.$t(`search.product_type_codes.${this.category}`)
    },
    pageTitle() {
      let title = ''
      title += this.watchedQuery
      if (this.watchedCategory) title += ` | ${this.watchedCategory}`
      title += ' | Gocase'
      return title
    },
    gtmObject() {
      return {
        productsIds: this.products
          .slice(0, GTM_PRODUCTS_QUANTITY)
          .reduce((ids, product) => {
            ids.push(product.id)

            return ids
          }, []),
        query: this.query,
        value: this.products[0]?.price || 0.0,
      }
    },
  },
  watchQuery: true,
  watch: {
    query() {
      this.sendToGtm()
    },
  },
  mounted() {
    this.sendToGtm(true)
  },
  methods: {
    sendToGtm(isPageView = false) {
      this.pushDataLayer({
        event: 'genericEvent',
        eventCategory: 'navigation',
        eventAction: 'search',
        eventValue: Object.assign({ isPageView }, this.gtmObject),
        ga4EventValue: {},
      })
    },
  },
  head() {
    return {
      title: this.pageTitle,
    }
  },
}
</script>
